module.exports = __webpack_public_path__ + "media/images/flags/16/Cuba-ee73dc3a5770dca208b1d62350bae26a.png";